const initialState = {
	"bullet": 0,
	"listado": []
};

export function notificacionesRdc(state = initialState, action) {
	switch (action.type) {
	case "NOTIFICACIONES_LLENAR":
		return {...state,
			"bullet": action.bullet,
			"listado": action.listado
		};
	case "NOTIFICACIONES_SET_EVENT":
		return {...state,
			"evento": action.evento
		};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/notificaciones/reducer.js